__webpack_require__.p = "/app/themes/appeal-base/dist/";